// store.ts
import { configureStore } from "@reduxjs/toolkit";
import someReducer from "./reducer";
import { setStore } from "../service/storeRef";
import formSlice from "./formSlice";
import authSlice from "./authSlice";
import appSettingsSlice from "./appSettingsSlice";
import modelDialogReducer from "./modelDialogReducer";
import formUpdateReducer from "./formUpdateReducer";
import value from "./valueSlice";
import headerValue from "./headerValue";
import {
  clientpartner,
  clientReducer,
  clientsArray,
  conditionalclientpartner,
  filter,
  list,
  partnerIdsReducer,
  partnersArray,
  selectionFilter,
  splits,
  tableReducer,
} from "./clientSlice";
import tableDatas from "./tableDataSlice";
import clientPartnerSplit from "./splitSlice";
import splitData from "./dynamicResponse";
import loading from "./loader";
import activeClientSlice from "./activeClientSlice";
import commission from "./Commission/commissionSlice";
import assetsSlice from "./Case/assetSlice";
import liabilitiesSlice from "./Case/liabilitySlice";
import policiesSlice from "./Case/policySlice";
import opentimer from "./timerSlice";
import filterDate from "./Commission/FilterSlice";
import preferences from "./preferenceSlice";
import timeAllocation from "./timeAllocationSlice";
import providersSlice from "./providersSlice";
import string from "./SavedSearch/searchId";
import updatestring from "./SavedSearch/updateSearchId";
import selectionType from "./SavedSearch/extractTypes";
import ruleid from "./distributionRuleSlice";
import incomeCategoriesSlice from "./SystemManager/incomeCategories";
import expenseCategoriesSlice from "./SystemManager/expenseCategories";
import attitudeToRiskCategoriesSlice from "./SystemManager/attitudeToRiskCategories";
import attitudeToRiskRatingsSlice from "./SystemManager/attitudeToRiskRatings";
import objectivesSlice from "./SystemManager/objectives";
import caseActionsSlice from "./SystemManager/caseActions";
import clientActionsSlice from "./SystemManager/clientActions";
import userDefinedFieldsSlice from "./SystemManager/userDefinedFields";
import commissionRulesSlice from "./SystemManager/commissionRules";
import commissionTypesSlice from "./SystemManager/commissionTypes";
import manageUserSlice from "./SystemManager/manageUser";
import portal from "./clientPortal/clientPortalslice";
import clientContactsSlice from "./Client/contacts";
import feesAndChargesSlice from "./Client/feesAndCharges";
import vulnerabilitySlice from "./Client/vulnerability";
import partnerVulnerabilitySlice from "./Client/Partner/partnerVulnerability";
import clientPartner from "./clientPortal/clientPartnerSlice";
import bulkValuation from "./SystemManager/bulkValuationSlice";
import distributionSlice from "./Commission/distributionSlice";
import clientListSlice from "./Client/clientListSlice";
import extract from "./savedSearchSlices/extractSlice";
import fileUploadReducer from "./S3FileUpload/fileUploadSlice";
import documentSlice from "./Document/documentSlice";
import fileLinkSlice from "./Document/fileLinkSlice";
import commissionStatementReducer from "./Commission/commissionStatementSlice";

const store = configureStore({
  reducer: {
    someReducer: someReducer,
    formSettings: formSlice,
    authUser: authSlice,
    appSettings: appSettingsSlice,
    dialog: modelDialogReducer,
    formUpdated: formUpdateReducer,
    value: value,
    clientid: clientReducer,
    headerValue: headerValue,
    tableData: tableReducer,
    partnerId: partnerIdsReducer,
    clients: clientsArray,
    partner: partnersArray,
    client: splits,
    tableDatas: tableDatas,
    clientPartnerSplit: clientPartnerSplit,
    splitData: splitData,
    loading: loading,
    list: list,
    clientpartner: clientpartner,
    conditionalclientpartner: conditionalclientpartner,
    selectionFilter: selectionFilter,
    filter: filter,
    activeClient: activeClientSlice,
    commission,
    opentimer: opentimer,
    filterDate: filterDate,
    assets: assetsSlice,
    liabilities: liabilitiesSlice,
    policies: policiesSlice,
    providers: providersSlice,
    string: string,
    updatestring: updatestring,
    selectionType: selectionType,
    timeAllocation,
    ruleid: ruleid,
    incomeCategories: incomeCategoriesSlice,
    expenseCategories: expenseCategoriesSlice,
    attitudeToRiskCategories: attitudeToRiskCategoriesSlice,
    attitudeToRiskRatings: attitudeToRiskRatingsSlice,
    objectives: objectivesSlice,
    caseActions: caseActionsSlice,
    clientActions: clientActionsSlice,
    userDefinedFields: userDefinedFieldsSlice,
    commissionRules: commissionRulesSlice,
    commissionTypes: commissionTypesSlice,
    manageUser: manageUserSlice,
    clientContacts: clientContactsSlice,
    feesAndCharges: feesAndChargesSlice,
    vulnerability: vulnerabilitySlice,
    partnerVulnerability: partnerVulnerabilitySlice,
    portal,
    clientPartner,
    bulkValuation,
    distribution: distributionSlice,
    clientList: clientListSlice,
    preferences,
    extract,
    fileUpload: fileUploadReducer,
    documents: documentSlice,
    fileLink: fileLinkSlice,
    commissionStatement: commissionStatementReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: ["commissionStatement.selectedExpectationIds"],
      },
    }),
});
setStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
